'use client';
var SkuTier;
(function (SkuTier) {
    SkuTier["BASE"] = "BASE";
    SkuTier["PRO"] = "PRO";
    SkuTier["ELITE"] = "ELITE";
    SkuTier["ELITE_PLUS"] = "ELITE_PLUS";
})(SkuTier || (SkuTier = {}));

export { SkuTier };
//# sourceMappingURL=order.js.map
